import { type BaseProductElementProps } from "~/feature/Product/types";
import { useProductContext } from "~/feature/Product/ProductContext";

import classes from "./PrimaryImageWithLogos.module.less";
import classNames from "classnames";
import { PrimaryImage } from "~/feature/Product/elements/PrimaryImage";

type Sizes = "tiny" | "small" | "huge";
interface Props extends BaseProductElementProps {
  size?: Sizes;
  clickable?: boolean;
  linkProps?: JSX.IntrinsicElements["a"];
}

const sizeCls: Record<Sizes, string> = {
  tiny: classes.sizeTiny,
  small: classes.sizeSmall,
  huge: classes.sizeHuge,
};

export const PrimaryImageWithLogos = (props: Props) => {
  const { size = "small", clickable = true, linkProps } = props;
  const product = useProductContext(props);

  return (
    <div className={classNames(classes.root, sizeCls[size], props.className)}>
      <PrimaryImage className={classes.image} clickable={clickable} linkProps={linkProps} />
      {product.brandLogoUrl && <img className={classes.brandLogo} src={product.brandLogoUrl} alt={""} />}
      {product.manufacturerLogoUrl && (
        <img className={classes.manufacturerLogo} src={product.manufacturerLogoUrl} alt={""} />
      )}
    </div>
  );
};
